/**
 * Formats milliseconds into a zero-padded HH:MM:SS string.
 */
export function formatHHMMSS(ms) {
    if (!ms || ms < 0) return '00:00:00';
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return [h, m, s].map((v) => String(v).padStart(2, '0')).join(':');
}

export function formatMs(ms) {
    if (!ms || ms <= 0) return '0h 0m';
    const totalMinutes = Math.floor(ms / 60000);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${h}h ${m}m`;
}

export function parseEstimatedMs(str) {
    if (!str) return 0;
    let ms = 0;
    const hMatch = str.match(/(\d+)h/);
    const mMatch = str.match(/(\d+)m/);
    if (hMatch) ms += parseInt(hMatch[1]) * 3600000;
    if (mMatch) ms += parseInt(mMatch[1]) * 60000;
    return ms;
}
export function parseDurationStringToMs(duration) {
    if (!duration) return 0;
    const match = String(duration).match(/(?:(\d+)h\s*)?(?:(\d+)m\s*)?(?:(\d+)s)?/);
    if (!match) return 0;
    const hours = parseInt(match[1] || 0, 10);
    const minutes = parseInt(match[2] || 0, 10);
    const seconds = parseInt(match[3] || 0, 10);
    return (hours * 3600 + minutes * 60 + seconds) * 1000;
}

export function getRunningTaskSegmentMs(attendanceTask, now = Date.now()) {
    if (!attendanceTask?.taskHistory?.length) return 0;
    const latestLog = attendanceTask.taskHistory[attendanceTask.taskHistory.length - 1];
    if (latestLog?.action !== 'start' || !latestLog.time) return 0;
    return Math.max(0, now - new Date(latestLog.time).getTime());
}

export function buildEstimatedTimeString(h, m) {
    const hours = Math.max(0, parseInt(h) || 0);
    const minutes = Math.max(0, parseInt(m) || 0);
    if (hours === 0 && minutes === 0) return '';
    if (hours === 0) return `${minutes}m`;
    if (minutes === 0) return `${hours}h`;
    return `${hours}h ${minutes}m`;
}

export function parseEstimatedTimeString(str) {
    if (!str) return { h: 0, m: 0 };
    const trimmed = String(str).trim();
    const hMatch = trimmed.match(/(\d+(?:\.\d+)?)\s*(?:h|hr|hours?)/i);
    const mMatch = trimmed.match(/(\d+)\s*(?:m|min|minutes?)/i);
    if (hMatch || mMatch) {
        const floatH = hMatch ? parseFloat(hMatch[1]) : 0;
        const wholeH = Math.floor(floatH);
        const extraM = Math.round((floatH - wholeH) * 60);
        const m = (mMatch ? parseInt(mMatch[1], 10) : 0) + extraM;
        return {
            h: wholeH + Math.floor(m / 60),
            m: m % 60,
        };
    }
    const num = parseFloat(trimmed);
    if (!isNaN(num) && num > 0) {
        const wholeH = Math.floor(num);
        const m = Math.round((num - wholeH) * 60);
        return { h: wholeH, m };
    }
    return { h: 0, m: 0 };
}

export function msToHM(ms) {
    if (!ms || ms <= 0) return { h: 0, m: 0 };
    const totalMinutes = Math.floor(ms / 60000);
    return { h: Math.floor(totalMinutes / 60), m: totalMinutes % 60 };
}

export function hmToMs(h, m) {
    const hours = Math.max(0, parseInt(h) || 0);
    const minutes = Math.max(0, parseInt(m) || 0);
    return ((hours * 60) + minutes) * 60000;
}
